import {Survey} from 'core/SurveyModels'
import {SurveyValidatorCondition} from 'core/builder/validators/SurveyValidatorCondition'
import {
  SurveyValidator,
  SurveyValidatorResult
} from 'core/builder/validators/SurveyValidator'
import {SurveyValidatorError} from 'core/builder/validators/SurveyValidatorErrorText'
import {SurveyValidatorBasicAttribute} from 'core/builder/validators/SurveyValidatorBasicAttributes'
import {SurveyValidatorPages} from 'core/builder/validators/SurveyValidatorPages'
import {SurveyValidatorElementNames} from 'core/builder/validators/SurveyValidatorElementNames'
import {SurveyValidatorBranches} from 'core/builder/validators/SurveyValidatorBranches'

export class SurveyValidatorService {
  validate(survey: Survey): Promise<SurveyValidatorResult[]> {
    return this.custom([
      new SurveyValidatorCondition(survey),
      new SurveyValidatorError(survey),
      new SurveyValidatorBasicAttribute(survey),
      new SurveyValidatorPages(survey),
      new SurveyValidatorElementNames(survey),
      new SurveyValidatorBranches(survey)
    ])
  }

  async custom(validators: SurveyValidator[]) {
    return (
      await Promise.all(validators.map((validator) => validator.result()))
    ).flat()
  }
}
